<template>
  <div class="container">
    <Id v-if="$i18n.locale === 'id'" />
    <En />
  </div>
</template>

<script>
import En from '@/views/FAQ/En.vue'
import Id from '@/views/FAQ/Id.vue'
export default {
  name: 'FAQ',
  components: {
    En,
    Id
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}
</style>
